// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__-BviW","main":"Layout_main__IBKnx"};